import { InjectionToken } from '@angular/core'

import { FeatureMap } from '../feature-flags/feature-flags.model'

export interface Environment {
  production: boolean

  apiUrl: string
  socketUrl: string

  tenantId: string

  posthog: {
    apiKey: string
    apiHost: string
  }

  hasura: {
    apiUrl: string
    adminSecret: string
    tenantId: string
  }

  features: FeatureMap
}

export const ENVIRONMENT = new InjectionToken<Environment>('Environment token')
